













































































import { Component, mixins } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { Data } from '@/modules/shared/models/data'
import Tooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import { FaqCollectionModel } from '@/modules/faq/models/faq-collection.model'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import QTable from 'quasar/src/components/table/QTable.js';

@Component({
  components: { FilterRow, Heading, BaseInput, BaseButton, Tooltip }
})
export default class FaqPage extends mixins(QsSearchableMixin) {
  constructor() {
    super()
  }

  @Prop() faqs !: Data<FaqCollectionModel[]>

  private faqsColumn: QTable['columns'] = [
    {
      name: 'question',
      label: 'عنوان سوال',
      field: 'question',
      align: 'left'
    }
  ]


}
